import { MOBILITY_DEFAULT_CURRENCY_CODE } from '@bos/mobility-ui';
import { lazyRouteComponent, createRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MobilityScopeV5x4 } from '../../../../../api/generated/cz.partners.bank.backofficegateway.mobility';
import { clientAccountsPageValidateSearchSchema } from '../../../products/ClientAccountsPage/route';
import { createIncomingMobilityRoute } from '../route';

const createIncomingMobilityRecapitulationRouteSearchSchema =
	clientAccountsPageValidateSearchSchema.extend({
		otherBankPrefix: z.string().optional().prefault(''),
		otherBankAccount: z.string(),
		otherBankCode: z.string(),
		otherBankCurrencyCode: z.enum([MOBILITY_DEFAULT_CURRENCY_CODE]),
		date: z.coerce.date(),
		scope: z.array(z.enum(MobilityScopeV5x4)),
		accountUuid: z.string(),
	});

export type CreateIncomingMobilityRecapitulationRouteSearchSchema = z.infer<
	typeof createIncomingMobilityRecapitulationRouteSearchSchema
>;

export const createIncomingMobilityRecapitulationRoute = createRoute({
	getParentRoute: () => createIncomingMobilityRoute,
	path: '/1-recapitulation',
	component: lazyRouteComponent(
		() => import('./CreateIncomingMobilityRecapitulationPage'),
		'CreateIncomingMobilityRecapitulationPage',
	),
	validateSearch: createIncomingMobilityRecapitulationRouteSearchSchema,
});
